import { componentName, PolicyValidationClass } from './PolicyValidationClass';

customElements.define(componentName, PolicyValidationClass);

export { PolicyValidationClass, componentName };
